import { createRoute, Navigate } from '@tanstack/react-router';
import LoadingScreen from 'components/LoadingScreen';
import OnboardingLayout from 'layouts/OnboardingLayout';
import { rootRoute } from 'routes/rootRoute';
import { canAccessOnboardingPages, WithEnsure } from 'routes/routeUtils';

export const onboardingParentRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => WithEnsure(canAccessOnboardingPages, <OnboardingLayout />),
  path: '/onboarding',
  pendingComponent: LoadingScreen,
});

export const onboardingIndexRoute = createRoute({
  getParentRoute: () => onboardingParentRoute,
  path: '/',
  component: () => <Navigate to="/onboarding/pharmacist_or_lab" />,
});
